// removed by extract-text-webpack-plugin
module.exports = {"content":"PrivacyPolicy__content__36fw8","parentContainer":"PrivacyPolicy__parentContainer__a7Hh5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PrivacyPolicy/PrivacyPolicy.css
// module id = 1022
// module chunks = 0